<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block"> {{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <div class="body" style="padding: 16px 24px 16px 24px;">
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">Domicile:<span style="color:#ff0000">*</span></label>
                <mat-form-field appearance="outline" class="fixed-select" subscriptSizing="dynamic"
                    style="width: 100%;">
                    <mat-select [(ngModel)]="domicile" placeholder="Select" [disabled]="eventType === 'EDIT'">
                        <mat-option>
                            <ngx-mat-select-search [formControl]="domicileFilterCtrl" placeholderLabel="Search"
                                noEntriesFoundLabel="No results found">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let option of filteredDomicileList | async" [value]="option">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">Daily Expedite Rate (%):<span style="color:#ff0000">*</span></label>
                <input type="text" style="width: 86%;" class="category" [(ngModel)]="dailyexpediteRate"
                    (keyup)="validate($event,'value')" (keypress)="keyPressAlphaNumeric($event)">
            </div>
        </div>
        <!-- Period -->
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">Period<span style="color:#ff0000">*</span></label>
                <select [(ngModel)]="selected_period_id" style="width: 86%;" [ngModelOptions]="{standalone: true}"
                    class="category" [disabled]="eventType=='EDIT'">
                    <option *ngFor="let toPeriod of toPeriodList" [value]="toPeriod.periodId">
                        {{ toPeriod.period }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
        <button (click)="onNoClick()" class="mCancel">CANCEL</button>
        <button mat-raised-button class="black-btn" style="display: inline;" (click)="saveClick()">SAVE</button>
    </div>
</div>